import queries from '@apis/queries';
import useToast from '@hooks/ui/useToast';
import { useFlow } from '@router/stackflow';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';

function usePrepaidCardImages() {
  const { data, status } = useQuery(queries.prepaidCardImages.list());
  const { pop } = useFlow();
  const toast = useToast();
  const images = data?.categories;
  const isLoading = status === 'pending';
  const isBlank = !isLoading && (!images || images.length === 0);
  useEffect(() => {
    if (status === 'error') {
      pop();
      toast.error('선불카드 이미지 조회 중 오류가 발생하였습니다.');
    }
  }, [toast, status]);
  return { images, isLoading, isBlank };
}

export default usePrepaidCardImages;
